import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { AngularMaterialModule } from 'src/app/material.module';
import { ContainerMarginRoutingModule } from './container-margin-routing.module';
import { ContainerMarginWindowComponent } from './container-margin-window/container-margin-window.component';
import { ContainerMarginFormComponent } from './container-margin-form/container-margin-form.component';


@NgModule({
  declarations: [
    ContainerMarginWindowComponent,
    ContainerMarginFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    ContainerMarginRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } }
  ]
})
export class ContainerMarginModule { }
